import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=a34e3972&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=a34e3972&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34e3972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a34e3972')) {
      api.createRecord('a34e3972', component.options)
    } else {
      api.reload('a34e3972', component.options)
    }
    module.hot.accept("./goodsList.vue?vue&type=template&id=a34e3972&scoped=true", function () {
      api.rerender('a34e3972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/goodsList.vue"
export default component.exports